import React, { ReactElement, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CalendarServiceInfo } from '../CalendarServiceInfo';
import Button from 'components/base/Button';

import { Column } from 'components/base/Column';
import CustomIcon from 'components/base/CustomIcon';
import './index.scss';
import { Navigate } from 'components/base/Navigate';
import { Row } from 'components/base/Row';
import Tooltip from 'components/base/Tooltip';

import { ExtendedEvent } from 'models/Event';
import { formatName } from 'utils/helpers';

type EventAgendaProps = {
  event: ExtendedEvent;
};

const EventAgenda = ({ event }: EventAgendaProps): ReactElement => {
  const { t } = useTranslation();
  const [showExtra, setShowExtra] = useState<boolean>(false);

  const onShowInfoClick = useCallback(() => {
    if (event.serviceId) {
      setShowExtra(true);
    }
  },
  [event.serviceId]);

  return (
    <React.Fragment>

      <div className="event-agenda">
        <Column>
          <Row className="f-event-agenda-header" justifyContent="flex-start">
            <Tooltip className="f-event-agenda-header-icon" content={t('order.details.details')}>
              <Button
                className="f-exta-info-button"
                color="transparent"
                rightAddon={<CustomIcon icon={event.type} />}
                onClick={onShowInfoClick}
              />
            </Tooltip>
            <div className="event-record">
              {event.erpId}
            </div>
            <div className="event-users">
              {event.deceased && (
              <Navigate
                to={`/records/${event.recordId}/edit`}
              >
                {formatName(event.deceased)}
              </Navigate>
              )}
            </div>
          </Row>
        </Column>
      </div>
      <CalendarServiceInfo
        erpId={Number(event.erpId)}
        postCeremonyId={event.postCeremonyId || null}
        serviceId={event.serviceId}
        show={showExtra}
        type={event.type}
        onCancel={() => setShowExtra(false)}
      />
    </React.Fragment>
  );
};

export default EventAgenda;
